import { logger } from '@/logging/logger'

export default {
    async reset({ dispatch, rootGetters }, payload = { force: false }) {
        return Promise.all([
            dispatch('stream/reset', payload),
            dispatch('collect/reset', payload),
            dispatch('mrx/reset', payload),
            dispatch('session/reset', payload),
            dispatch('track/reset', payload),
            dispatch('rdt/reset', payload),
            dispatch('observation/reset', payload),
        ])
    },

    async init({ dispatch, rootState, rootGetters }) {
        try {
            if (rootGetters['v4/session/authenticated']) {
                logger.info('auth', 'session.restore.attempt', undefined, 'Session restore started with authenticated cookie state').then();
                let response = await fetch('api/v3/conf.json')

                if (response.ok) {
                    let conf = await response.json()
                    logger.info('auth', 'session.restore.success', { status: response.status }, 'Session restore succeeded with remote config').then();

                    if (conf.hashes.preferences !== rootState.hashes.preferences) {
                        await dispatch('setPreferences', { preferences: conf.preferences, hash: conf.hashes.preferences }, { root: true })
                    }

                    rootState.tracks = conf.tracks
                    rootState.settings = conf.settings
                    rootState.session = conf.session
                    rootState.release = conf.release
                    rootState.v4.settings = rootState.v4.settings || {}
                    rootState.v4.settings.defaults = conf.v4.settings
                    rootState.v4.language.all = conf.settings.languages
                    dispatch('mrx/load')
                } else {
                    logger.warn('auth', 'session.restore.failed', { status: response.status }, 'Session restore failed to load remote config').then();
                }
            } else {
                logger.warn('auth', 'session.restore.skipped', { authenticated: false }, 'Session restore skipped because authentication cookies are missing').then();
            }

            await dispatch('language/load')
            await dispatch('registration/register')
            await dispatch('language/set')
        }
        catch (e) {
            logger.error('app.lifecycle', 'store.init', { message: e?.message }, 'Error during store init').then();
        }

        return true
    }
}
